var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tx-lt pd-tb-10"},[_c('i',{staticClass:"el-icon-back clr-4fb cursor-p",staticStyle:{"font-size":"40px"},on:{"click":_vm.goBack}})])
}
var staticRenderFns = []

export { render, staticRenderFns }